module.exports = __webpack_public_path__ + "img/qz_btn.cc1cf099.png";